export default __webpack_public_path__ + "static/media/favicon.4e28c178.ico";